import { defineComponent as _defineComponent } from 'vue'
import { BendTrendChronologicalProductivitySummaryData } from '@/models/Charts/chartsData';
import SummaryComparisonKpiWidget from '../common/kpiWidget/SummaryComparisonKpiWidget.vue';
import { ChartGenerator } from '@/models/Charts/abstract/chartGenerator';
import { computed } from 'vue';
import { isNil } from '@/utils/misc';
import WidgetDefinition from '@/models/Charts/widgetDefinition';
import { formatPercentage, formatWithUnit } from '@/utils/number';
import { useI18n } from '@/composables/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'BendTrendChronologicalProductivitySummaryKpiWidget',
  props: {
    data: null,
    generator: null,
    widgetDefinition: null,
    loading: { type: Boolean },
    isFetchingForTheFirstTime: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  data: BendTrendChronologicalProductivitySummaryData | null;
  generator: ChartGenerator<BendTrendChronologicalProductivitySummaryData>;
  widgetDefinition: WidgetDefinition;
  loading: boolean;
  isFetchingForTheFirstTime: boolean;
};



const { t } = useI18n();

const mainFact = computed<number>(
  () => props.data?.productivityPercentage ?? 0,
);

const bendingTime = computed<string>(() =>
  formatWithUnit(props.data!.bendingTimeSeconds / 3600, 'h'),
);

const standbyTime = computed<string>(() =>
  formatWithUnit(props.data!.standbyTimeSeconds / 3600, 'h'),
);

return { __sfc: true,props, t, mainFact, bendingTime, standbyTime, SummaryComparisonKpiWidget, isNil, formatPercentage }
}

})